class ProductsSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiperBar = '.js-products-swiper-scroll';
    const pageNation = '.swiper-wrapper';
    let pageNationCount = $(pageNation).find('.swiper-slide').length;
    let swiperBarHeight = $(swiperBar).outerHeight();
    const swiperBarGrow = 100 / pageNationCount;
    console.log(swiperBarGrow);
    console.log(swiperBarHeight);
    console.log(pageNationCount);
    $(swiperBar).find('span').css('height',swiperBarGrow + '%');
    const swiperBarChange = function(slideNum){
      // console.log(swiperBarGrow);
      // console.log(slideNum);
      let Grow = swiperBarGrow * slideNum;
      // if(pageNationCount == slideNum){
      //   Grow = 100;
      // }else{
      //   Grow = swiperBarGrow * slideNum;
      // }
      $(swiperBar).find('span').css('height',Grow + '%');
      console.log(Grow);
    }
    const swiper = new Swiper('.' + this.el, {
      speed: 500,
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          // スライダーの画像のsrcを取得して、それをページネーションのサムネイルとして使用
          var src = document.querySelectorAll('.swiper-slide img')[index + 1].getAttribute('src');
          return '<span class="' + className + '"><img src="' + src + '" alt="" width="50"></span>';
        }
      },
      on: {
        slideChange: function(){
          let slideNum = this.activeIndex;
          swiperBarChange(slideNum);
        }
      }
    })
  }
}
